import $ from 'jquery';
import './velocity.min';
import './velocity-ui';
import {Scheduler} from './Scheduler.js';

import './mobile-check';
import {consent} from './consent.js';
import {slideTo} from './functions';
import AOS from 'aos';
import './text-animation';
import {CirclesAnimation, SVGSingleAnimator} from './svg-animation';

Velocity.patch(window, true);
Velocity.patch(Element && Element.prototype);
Velocity.patch(NodeList && NodeList.prototype);
Velocity.patch(HTMLCollection && HTMLCollection.prototype);

Velocity.patch($, true);
Velocity.patch($ && $.fn);

window.jQuery = $;
window.$ = $;

const minWidth = 920;
const isMobileOrTablet = window.isMobileOrTablet;
var $window = $(window);
var $document = $(document);

if (isMobileOrTablet) {
    document.body.classList.add('mobile');
}

function haveSetCookieParameter() {
    return window.location.href.endsWith('?enter_uat_kingdom');
}

if (haveSetCookieParameter()) {
    document.cookie = 'webinico15uat=1';
    location.replace('/');
}

(function($) {
    var $body = $('body'),
        numberAnimationCount = 0,
        $headers = $('h1, h2, h3, h4, h5, h6').not('.animate-number-count'),
        $slid = $('.slide'),
        WBN = {
            animations: {
                countToTargetNumber: function($el, now) {
                    var floatVal = '',
                        targetInt = $el.data('animation-target-number'),
                        intVal,
                        actualFloat,
                        after = $el.data('animation-text-after'),
                        match = after.match(/^([.,])([0-9]+)/);

                    if (targetInt === '') {
                        intVal = '';
                    } else if (match !== null) {
                        actualFloat = now * parseFloat(targetInt + '.' + match[2]);
                        actualFloat = actualFloat.toString().match(/([0-9]+)\.([0-9]+)/);
                        if (actualFloat !== null) {
                            if (typeof actualFloat[1] !== undefined) {
                                intVal = actualFloat[1];
                            }
                            if (typeof match[1] !== undefined && typeof actualFloat[2] !== undefined) {
                                floatVal = match[1] + actualFloat[2].substr(0, match[2].length);
                            }
                        }
                        if (typeof match[0] !== undefined) {
                            after = after.substr(match[0].length);
                        }
                    } else {
                        intVal = Math.ceil(now * targetInt);
                    }
                    $el.text(
                        $el.data('animation-text-before')
                        + intVal
                        + floatVal
                        + after
                    );
                },
                codeAnimate: function($el) {
                    var $image = $el.find('.code-animation-image').eq(0),
                        time = Math.round(Math.random() * 1000) + 400,
                        length = Math.round(Math.random() * 20) + 15,
                        imageHeight = $image.height(),
                        top = parseInt($el.css('top')),
                        goToStart = false;

                    if (imageHeight + top < length) {
                        length = imageHeight + top;
                        goToStart = true;
                    }

                    $el.stop().velocity({
                        top: top - length
                    }, time, function() {
                        if (goToStart) {
                            $el.css('top', 0);
                            $el
                                .find('.code-animation-image')
                                .eq(1)
                                .prependTo($el);
                        }
                        WBN.animations.codeAnimate($el);
                    });
                }
            },
            init: {
                load: {
                    desktop: function() {
                        $('.animate-number-count, .number-box h3').not('[data-aos]').each(function() {
                            var $t = $(this);

                            $t
                                .attr('data-aos', 'number-count')
                                .attr('data-offset', 0)
                                .attr('data-aos-id', 'number-count-' + ++numberAnimationCount);

                            $document.one('aos:in:number-count-' + numberAnimationCount, function(details) {
                                var $b = $('[data-aos-id=' + details.type.substr(7) + ']'),
                                    before,
                                    after,
                                    bText = $b.text(),
                                    targetNumber = bText.match(/[0-9]+/);

                                if (bText === '') {
                                    return;
                                }

                                if (Array.isArray(targetNumber)) {
                                    targetNumber = parseInt(targetNumber[0]);
                                } else {
                                    targetNumber = '';
                                }
                                if (isNaN(parseInt(bText))) {
                                    before = bText.match(/[^0-9]+/)[0];
                                    after = bText.substr(targetNumber.toString().length + before.length);
                                } else {
                                    before = '';
                                    after = bText.substr(targetNumber.toString().length);
                                }
                                $b.data({
                                    'animation-target-number': targetNumber,
                                    'animation-text-after': after,
                                    'animation-text-before': before
                                });
                                $b.velocity({now: '100'}, {
                                    step: function(now) {
                                        WBN.animations.countToTargetNumber($b, now / 100);
                                    },
                                    complete: function() {
                                        $b.text(bText);
                                    },
                                    duration: 2000
                                });
                            });
                        });

                        $('.code-animation').each(function() {
                            var $this = $(this),
                                $imagesContainer = $this.find('.code-animation-images-container');

                            if (checkIfUcBrowser()) {
                                $imagesContainer.hide();
                            } else {
                                $this
                                    .find('.code-animation-image')
                                    .clone()
                                    .removeClass('lazy')
                                    .appendTo($imagesContainer);

                                WBN.animations.codeAnimate($imagesContainer);
                            }
                        });

                        afterConversion();
                    },
                    all: function() {
                        animateHeaders();
                        consent($);
                        pageScrollEvent();

                        AOS.refreshHard();
                        AOS.refresh(true);
                        $('.talk-about').find('a').not('[href]').attr('href', '/contact');
                        $('.service-info-list-columns ul').addClass('check-list check-list-animate');
                        $('a').filter('[href="https://webini.pl/case-studies"]').attr('href', '/case-studies');

                        if ($('.slide-video').parent().is(':visible')) {
                            $slid.on('slide:show', '.slide-video', function() {
                                let $this = $(this),
                                    $container = $this.closest('.slide-image-container'),
                                    $video = $container.find('video').first();

                                $video.get(0).play();
                            });
                        } else {
                            $('.slide-image-mobile').each((i, elem) => {
                                const $elem = $(elem);

                                $elem.append(`<img src="${$elem.data('src')}" alt="${$elem.data('alt')}"/>`);
                            });
                        }
                    }
                },
                desktop: function() {
                    $slid.find('img').on('img2svg:replaced', function(e, $svg) {
                        $svg.find('.pattern').not('.dots-prepared').each(function() {
                            CirclesAnimation.prepareShowDots.call(this, true);
                        });
                        $svg
                            .find('g')
                            .not('.pattern')
                            .find('path, rect, polyline, circle')
                            .css('visibility', 'hidden');
                    });
                }
            },
            events: {
                init: function() {
                    var $btn = $('#scroll-to-top');

                    $btn.on('click', function(e) {
                        e.preventDefault();
                        $('html, body').velocity({scrollTop: 0}, 500);
                    });

                    $('.btn-nav').click(function() {
                        $('.main-nav-wrapper').addClass('show');

                        $('.main-nav li').each(function(i) {
                            var $that = $(this);

                            Scheduler.add(function() {
                                $that.addClass('show');
                            }, null, i * 100);
                        });

                        Scheduler.add(function() {
                            $('.main-nav .btn').addClass('show');
                            $('.lang-switch').addClass('show');
                        }, null, 700);

                    });

                    $('#close-nav').click(function() {
                        $('.main-nav-wrapper').removeClass('show');
                        $('.main-nav li').removeClass('show');
                        $('.main-nav .btn').removeClass('show');
                        $('.lang-switch').remove('show');
                    });

                    $('.scroll-to').on('click', function(e) {
                        var elementId = $(this)
                            .find('[href]')
                            .addBack('[href]')
                            .first()
                            .attr('href');

                        e.preventDefault();
                        slideTo($(elementId));
                    });
                }
            }
        };

    function pageScrollEvent() {
        var scrolled = false,
            timer = 0;

        $window.on('scroll', function() {
            var time = Date.now(),
                $btn = $('#scroll-to-top'),
                st;

            AOS.refresh(true);
            if (timer > time) {
                return;
            }

            st = $window.scrollTop();

            if (st > 20 && !scrolled) {
                $body.addClass('scrolled');
                scrolled = true;
                timer = time + 200;
            } else if (st <= 20 && scrolled) {
                $body.removeClass('scrolled');
                scrolled = false;
                timer = time + 200;
            }
            if (st > 600) {
                $btn.removeClass('hide fadeOutDown').addClass('fadeInUp');
            } else {
                $btn.removeClass('fadeInUp').addClass('fadeOutDown');
            }
        });
    }

    function animateHeaders() {
        $headers
            .not('.no-fade')
            .attr('data-aos', 'fade-up')
            .attr('data-aos-duration', '300')
            .attr('data-aos-offset', '100');
    }

    function initTextRotation() {
        $headers.find('em')
            .each(function() {
                let $t = $(this),
                    values;

                values = $t.attr('data-titles');
                if (typeof values === 'undefined') {
                    values = $t.text();
                }
                values = values.split('|');
                $t
                    .css('opacity', 1)
                    .text(values[0]);
                if (values.length > 1) {
                    $t.css('overflow', 'hidden');
                    fadeTextHeaderEm($t, values, 1);
                }
            });
    }

    function fadeTextHeaderEm($em, values, i) {
        let index = i % values.length;

        $em.velocity({'width': 0}, {
            duration: 700,
            complete: function() {
                let targetWidth;

                $em.text(values[index]);
                targetWidth = $em.css('width', 'auto').width();
                $em.css('width', 0).velocity({'width': targetWidth}, {
                    duration: 1000, complete: function() {
                        Scheduler.add(function() {
                            fadeTextHeaderEm($em, values, ++index);
                        }, null, 5000, true);
                    }
                });
            }
        });
    }

    function createOnScrollAnimation(selector, animationFunction) {

        selector = selector.split(/\s*,\s*/);
        if (selector.length === 0) {
            selector = selector.join(':not(.handled),');
        } else {
            selector = selector + ':not(.handled)';
        }

        $window.ready(function() {
            function onScroll() {
                var $objects = $(selector);

                if ($objects.length === 0) {
                    $window.off('scroll', onScroll);

                    return;
                }

                $objects.each(function() {
                    var $obj = $(this),
                        offset,
                        calculated;

                    offset = $obj.offset();
                    calculated = offset.top - $window.scrollTop() - $window.height();

                    if (calculated < 0) {
                        $obj.toggleClass('handled', true);
                        animationFunction.call($obj);
                        if ($(selector).length === 0) {
                            $window.off('scroll', onScroll);
                        }
                    }
                });
            }

            $window.on('scroll', function() {
                Scheduler.remove(onScroll, null);
                Scheduler.add(onScroll, null, 25);
            });
            Scheduler.add(onScroll, null, 50);
        });
    }

    function img2svg() {
        $('img').not('.img-no-convert').each(function() {
            var $that = $(this).addClass('img-no-convert'),
                $noConvertParent = $that.parents('.img-no-convert'),
                url = $that.attr('data-lazy-src'),
                className = $that.attr('class'),
                ext,
                $svg;

            if ($noConvertParent.length === 0) {
                if (url === undefined) {
                    url = $that.attr('src');
                }

                if (url !== undefined) {
                    ext = url.substr(url.lastIndexOf('.') + 1);
                }

                if (ext === 'svg') {
                    $.get(url, null, function(data) {
                        $svg = $('svg', data);

                        $svg.addClass(className)
                            .removeClass('lazy lazy-hidden')
                            .insertAfter($that);
                        $that
                            .trigger('img2svg:replaced', [$svg])
                            .remove();
                    });
                }
            }
        });
    }

    function afterConversion() {
        $('.quarter-circle, .quarter-lg-circle, .quarter-lg-small').not('.quarter-none').each(function() {
            var $newCircle = $(
                '<svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" class="animated-quarter"><circle stroke-width="40" r="20" fill="transparent" cx="-40" cy="40" stroke-dasharray="125.664 251.327" stroke="#111" transform="scale(-1 1)" style="opacity: 0"></circle></svg>'),
                classes,
                $this = $(this),
                k;

            classes = $this.attr('class').split(/\s+/);
            for (k in classes) {
                if (classes[k].indexOf('quarter') === 0) {
                    $newCircle.toggleClass(classes[k]);
                }
            }

            $this.addClass('quarter-none');
            $this.append($newCircle);

        });
        createOnScrollAnimation('.animated-ring', function() {
            let data = SVGSingleAnimator.getQuarterData($(this).find('circle').attr('r'));

            $(this).find('circle').css({
                'transition': 'stroke-dashoffset 1.5s',
                'transition-delay': '0.2s',
                'stroke-dashoffset': SVGSingleAnimator.getQuarterStrokeDashOffset(data, 200)
            });
        });
        createOnScrollAnimation('.animated-quarter', function() {
            let data = SVGSingleAnimator.getQuarterData($(this).find('circle').attr('r'));

            $(this).find('circle').css({
                'transition': 'stroke-dashoffset 1.5s, opacity 1.5s',
                'transition-delay': '0.2s',
                'stroke-dashoffset': SVGSingleAnimator.getQuarterStrokeDashOffset(data, 75),
                'opacity': 1
            });
        });
    }

    function addListIcons() {
        $('[class*="icon-list-"]').not('.icon-list-done').each(function() {
            var obj = $(this),
                iconName = obj.attr('class').split('icon-list-');
            obj.addClass('icon-list-done');
            iconName = iconName[1].split(' ');
            obj.find('li').prepend(
                '<img src="/wp-content/themes/webini/assets/svg/ic24-' + iconName[0] + '.svg" alt="">'
            );
        });
        img2svg();
    }

    function contentToggle($element, enableSlideTo = false) {
        $element.find('.content-toggle-item .content-toggle-header').each(function() {
            var $this = $(this);

            if ($this.parents('.content-toggle-item ').hasClass('only-mobile') && $window.width() >= minWidth) {
                return;
            }

            $(this).on('click', function(e) {
                var $toggleItem = $this.closest('.content-toggle-item'),
                    $toggleContent = $toggleItem.find('.content-toggle-content'),
                    wasOpened = $toggleItem.hasClass('opened');

                e.preventDefault();

                $('.content-toggle-item.opened:not(.toggle-stay)').removeClass('opened')
                    .find('.content-toggle-content').slideUp(200);

                if (!wasOpened) {
                    $toggleItem.addClass('opened');
                    $toggleContent.slideDown(200, function() {
                        if (enableSlideTo) {
                            slideTo($toggleItem);
                        }
                    });
                } else {
                    $toggleItem.removeClass('opened')
                        .find('.content-toggle-content').slideUp(200);
                }
                addListIcons();
            });
        });
    }

    function mobileSiteHeader() {
        let $pageHeader = $('#page-header');

        $pageHeader.find('.header-toggler').on('click', function() {
            $pageHeader.toggleClass('opened');
        });
    }

    function checkIfUcBrowser() {
        return navigator.userAgent.includes('UCBrowser');
    }

    function loadClutch() {
        setTimeout(function() {
            let clutchScript = document.createElement('script');

            $('body').append(clutchScript);
            clutchScript.onload = function() {
                window.CLUTCHCO.Init();
            };
            clutchScript.src = 'https://widget.clutch.co/static/js/widget.js';
        }, 3500);
    }

    if (!isMobileOrTablet) {
        WBN.init.desktop();
    }

    $document.ready(function() {
        contentToggle($('.faq-list'));
        contentToggle($('body.project-page'));
        contentToggle($('.offers-list'), true);
        addListIcons();
        mobileSiteHeader();
        loadClutch();

        AOS.init({
            startEvent: 'ready',
            duration: 350,
            mirror: false,
            once: true
        });

        $body.addClass('loaded');
        WBN.events.init();
    });

    $window.on({
        load: function() {
            Scheduler.add(initTextRotation, null, 2500);
            if (!isMobileOrTablet) {
                WBN.init.load.desktop();
            }
            WBN.init.load.all();
            window.dispatchEvent(new CustomEvent('scroll'));
        }
    });

}(jQuery));
